import React from "react";
import { Navigate } from "react-router-dom";
import AdminLayout from "./layouts/admin";
import PublicLayout from "./layouts/public";
import HomeAdmin from "./views/admin/HomeAdmin";
import Home from "./views/Home";
import OpcionsAdmin from "./views/admin/OpcionsAdmin";
import Login from "./views/Login";
import Ok from "./views/Ok";
import SorteigAdmin from "./views/admin/SorteigAdmin";
import ResultatsAdmin from "./views/admin/ResultatsAdmin";
import { Politica } from "./views/Politica";

const routes = (logged) => [
	{
		path: "/admin",
		element: logged ? <AdminLayout /> : <Navigate to="/login" />,
		children: [
			{
				path: "/admin/inscrits",
				element: <HomeAdmin />,
			},
			{
				path: "/admin/sorteig",
				element: <SorteigAdmin />,
			},
			{
				path: "/admin/resultats",
				element: <ResultatsAdmin />,
			},
			{
				path: "/admin/opcions",
				element: <OpcionsAdmin />,
			},
		],
	},

	{
		path: "/",
		element: <PublicLayout />,
		children: [
			{
				path: "/",
				element: <Home />,
			},
			{
				path: "/ok",
				element: <Ok />,
			},
			{
				path: "/login",
				element: !logged ? <Login /> : <Navigate to="/admin/inscrits" />,
			},

			{
				path: "/politica-privacitat",
				element: <Politica />,
			},
		],
	},
];

export default routes;
